export const ClientIds = {
	WORLDSUPERLEAGUE: "noku-worldsuperleague",
	WORLDSUPERLEAGUE_BETA: "noku-worldsuperleague-beta",
	WORLDSUPERLEAGUE_LOCALHOST: "noku-worldsuperleague-localhost",
	CRYPTOHEROES: "noku-cryptoheroes",
	CRYPTOHEROES_BETA: "noku-cryptoheroes-beta",
	CRYPTOHEROES_LOCALHOST: "noku-cryptoheroes-localhost",
	MARKETPLACE: "noku-marketplace",
	MARKETPLACE_BETA: "noku-marketplace-beta",
	MARKETPLACE_LOCALHOST: "noku-marketplace-localhost",
	WALLET: "noku-wallet",
	WALLET_ROPSTEN: "noku-wallet-ropsten",
	WALLET_LOCALHOST: "noku-wallet-localhost",
	ACCOUNTS: "noku-accounts",
	ACCOUNTS_ROPSTEN: "noku-accounts-ropsten",
	ACCOUNTS_LOCALHOST: "noku-accounts-localhost",
};
